import React from 'react';
import TextBox from 'devextreme-react/text-box';
import SelectBox from 'devextreme-react/select-box';
import { SnelStartSalesOrderTemplate } from '../../../api/company-settings';

type Props = {
  subscriptionKey: string;
  clientKey: string;
  templateId: string | null;
  hasSubscriptionKey?: boolean;
  hasClientKey?: boolean;
  templates: SnelStartSalesOrderTemplate[];
  onSubscriptionKeyChanged: (value: string) => void;
  onClientKeyChanged: (value: string) => void;
  onTemplateChanged: (value: string | null) => void;
};

export const SnelStartSettings = (props: Props) => (
  <div className='snelstart-settings'>
    <div className='form-row'>
      <TextBox label='Subscription key' labelMode='floating' mode='password' stylingMode='outlined'
        value={props.subscriptionKey} onValueChanged={(e) => props.onSubscriptionKeyChanged(e.value)}
        placeholder={props.hasSubscriptionKey ? 'Opgeslagen; laat leeg om te behouden' : 'Sleutel uit het SnelStart developer portal'} />
    </div>
    <div className='form-row'>
      <TextBox label='Koppelsleutel (client key)' labelMode='floating' mode='password' stylingMode='outlined'
        value={props.clientKey} onValueChanged={(e) => props.onClientKeyChanged(e.value)}
        placeholder={props.hasClientKey ? 'Opgeslagen; laat leeg om te behouden' : 'Koppelsleutel van uw SnelStart administratie'} />
    </div>
    <div className='form-row'>
      <SelectBox label='Verkoopsjabloon (optioneel)' labelMode='floating' stylingMode='outlined'
        items={props.templates.filter((t) => t.PrijsIngaveExclusiefBtw)} displayExpr='Omschrijving' valueExpr='Id'
        value={props.templateId} showClearButton
        onValueChanged={(e) => props.onTemplateChanged(e.value || null)}
        placeholder='Sla de koppeling op om sjablonen te laden' />
    </div>
    <p className='hint-text'>
      Gebruik de koppelsleutel van de juiste administratie uit SnelStart Web → Koppelingen.
      Bij opslaan wordt de verbinding gecontroleerd. Opgeslagen sleutels blijven verborgen.
    </p>
    <p className='hint-text'>
      Uren, materialen en kilometers worden als verkooporder geëxporteerd. Maak de factuur vervolgens
      in SnelStart. Gebruik artikelen met de activiteitnaam, GebruiktMateriaal en KM als artikelcode,
      en een verkoopsjabloon met prijzen exclusief btw.
    </p>
  </div>
);
